module.exports = __webpack_public_path__ + "static/media/Header_teacher.e8f90d80.jpg";